import { Component, OnInit } from '@angular/core';
import { Observable, Subject } from "rxjs";
import { Instructor } from "@modules/instructor/models/instructor";
import { TRANSLATION_SCOPE } from "@modules/instructor/i18n/scope";
import { INSTRUCTOR_PAGE_SIZE, InstructorPagination } from "@modules/instructor/models/instructor-pagination";
import { InstructorStoreService } from "@modules/instructor/client/store/instructor.store.service";
import { map, takeUntil } from 'rxjs/operators';
import { InstructorFilter } from "@modules/instructor/models/instructor-filter";
import { LocationApiService } from "@modules/location/store/services/location-api.service";
import { Location } from "@modules/location/models/location";
import { CourseTemplate } from "@modules/instructor/models/course-template";
import { InstructorApiService } from "@modules/instructor/client/services/instructor.api.service";
import { CategoryStoreService } from '@modules/category/client/store/category.store.service';
import { Category } from '@modules/category/models/category';

@Component({
  selector: 'app-instructor-list',
  templateUrl: './instructor-list.component.html',
  styleUrls: ['./instructor-list.component.scss']
})
export class InstructorListComponent implements OnInit {

  instructors$: Observable<Instructor[]>;
  regions$: Observable<Location[]>;
  templates$: Observable<CourseTemplate[]>;
  categories$: Observable<Category[]>;
  instructorFilter$: Observable<InstructorFilter>;
  isAllLoaded$: Observable<boolean>;

  translationScope = TRANSLATION_SCOPE;

  isLoadNext: boolean = false;

  unSubscribeAll$ = new Subject<void>();

  constructor(
    private instructorStoreService: InstructorStoreService,
    private instructorApiService: InstructorApiService,
    private locationApiService: LocationApiService,
    private categoryStoreService: CategoryStoreService
  ) { }

  ngOnInit(): void {
    this.getInstructors();
    this.getInstructorFilters();
    this.getRegions();
    this.getTemplates();
    this.getCategories();

    this.isAllLoaded$ = this.instructorStoreService.getIsAllLoaded();
  }

  ngOnDestroy(): void {
    this.unSubscribeAll$.next();
    this.unSubscribeAll$.complete();
  }

  loadMore(): void {
      this.instructorStoreService.fetchInstructorsPaginated();
  }

  private getInstructors() {
    this.instructors$ = this.instructorStoreService.getInstructors();
  }

  private getInstructorFilters(): void {
    this.instructorFilter$ = this.instructorStoreService.getInstructorFilters();
  }

  private getRegions(): void {
    this.regions$ = this.locationApiService.getAllLocation('').pipe(
      map(res => res.items)
    );
  }

  private getTemplates() {
    this.templates$ = this.instructorApiService.fetchCourseTemplate();
  }

  private getCategories() {
    this.categories$ = this.categoryStoreService.getAllCategories();
  }

  updateInstructorFilter(instructorFilter: InstructorFilter) {
    this.instructorStoreService.fetchInstructorsFiltered(instructorFilter, { pageIndex: 0, pageSize: INSTRUCTOR_PAGE_SIZE});
  }
}
